// import React, { useEffect } from "react";
// import { ReactComponent as ArrowRight } from "../../assets/developementservices/arrow-right.svg";
// import { Link, useLocation } from "react-router-dom";
import "./11.css"; // your existing CSS

// export const AnimatedButton = ({ link, label, onclick }) => {


//   return (
//     <Link
//       to={link}
//       className={`banner-btn banner-animated-btn`}
//       aria-label={label}
//       onClick={onclick}
//     >
//       <span className="banner-btn-text">{label}</span>
//       <span className="banner-btn-circle">
//         <ArrowRight className="banner-arrow-icon" />
//       </span>
//     </Link>
//   );
// };

import { Link } from "react-router-dom";
import { ReactComponent as ArrowRight } from "../../assets/work/arrow-right.svg";

export const AnimatedButton = ({ label, link, onClick }) => {
  // If 'link' is provided, render <Link>, else render <div>
  if (link) {
    return (
      <Link
        to={link}
        className="banner-btn banner-animated-btn"
        aria-label={label}
        onClick={onClick} // optional click handler
      >
        <span className="banner-btn-text">{label}</span>
        <span className="banner-btn-circle">
          <ArrowRight className="banner-arrow-icon" />
        </span>
      </Link>
    );
  }

  return (
    <div
      className="banner-btn banner-animated-btn"
      aria-label={label}
      onClick={onClick} // triggers form submission
      role="button" // accessibility
    >
      <span className="banner-btn-text">{label}</span>
      <span className="banner-btn-circle">
        <ArrowRight className="banner-arrow-icon" />
      </span>
    </div>
  );
};



/* 
.banner-animated-btn{
background-color:
}
*/